
let progressions = {

    base: [
        'first_steps',
        'first_steps_all_directions',
        'code_beats_visual',
        'repeat_code_beats_visual',
        'repeat_code_beats_visual_toric',
        'repeat_simple',    //Toric si vite ?
        'repeat_multiple',  //moins sympa que le suivant...
        'repeat_multiple_toric',
        'repeat_nested',
        'repeat_nested_double'
    ],


    conditions: [
        'condition_simple',
        'condition_simple_false',
        'conditional_repeat',
        'conditional_repeat_is_not_while',
        'conditional_repeat_double_action',
        'conditional_repeat_stuck',
        'conditional_repeat_all_useless',
        'conditional_repeat_many_useless',
        'conditional_reapeat_double_if',
        'repeat_nested_conditional'
    ],


    conditionsElse: [
        'condition_else',
        'condition_else_not_entering',
        'condition_else_double',
        'condition_else_if_second_true',
        'condition_else_if_first_true',
        'conditional_repeat_with_else',
        'conditional_repeat_with_else_if',
        'repeat_if_else'
    ],


    while: [
        'while',
        'while_double',
        'while_if',
        'while_nested',
        'while_within_repeat',
        'while_repeat'
    ],


    conditionsNegated: [
        'condition_negated_simple',
        'condition_negated_simple_true',
        'conditional_negated_repeat_simple',
        'conditional_negated_repeat_simple_many_useless',
        'condition_negated_while',
        'condition_negated_while_double',
        'condition_negated_repeat',
        'conditional_negated_repeat_with_else',
        'tetris',
        'while_nested_with_negated',
        'conditional_negated_double_repeat_with_else',
        'algo_read'
    ],


    functions: [
        'function_simple',
        'function_simple_extended',
        'function_simple_definition_first',
        'function_simple_carre',
        'function_double_run_jump',
        'function_within_repeat',
        'function_nested',
        'function_nested_containing_conditions',
        'recursive_function',
        'recursive_function_applied',
        'function_nested_with_heavy_context'
    ],

    dirty: [
        'dirty_functions_name_simple',
        'not_dirty_functions_name_simple',
        'dirty_functions_name_simple_2',
        'not_dirty_functions_name_simple_2',
        'dirty_syntax_simple',
        'not_dirty_syntax_simple',
        'dirty_syntax',
        'not_dirty_syntax',
        'dirty_syntax_hard',
        'not_dirty_syntax_hard',
        'dirty_complexity',
        'not_dirty_complexity',
        'dirty_hard',
        'not_dirty_hard'
    ],


    not_in_progression: [
        'boss_2',
        'callback',
        'function_as_argument',
        'function_as_argument_2',
        'function_repeat_volcano',
        'long_path',
        'loop_05',
        'puzzles/mix_incrementer',
        'puzzles/test_menu',
        'puzzles/transformation',
        'variable_repeat_if',
        'variable_repeat_simple'
    ]


}


progressions.python = [
    'first_steps',
    'first_steps_all_directions',
    'toric',
    'code_beats_visual_simple',
    'code_beats_visual',

    'while_too_simple',
    'while_simple',
    'while_simple_toric',
    'while_double_easier',
    'while_double_easier_and_finish',
    'while_double_long',
    'while_twice_toric',

    'for_introduction',
    'for_introduction_twice',

    'repeat_simple',
    'repeat_multiple',
    'repeat_multiple_toric',
    'repeat_nested',
    'repeat_nested_double'
]
    .concat(progressions.conditions)
    .concat(progressions.conditionsElse)
    .concat([
        'condition_negated_simple',
        'condition_negated_simple_true',
        'conditional_negated_repeat_simple',
        'conditional_negated_repeat_simple_many_useless',

        'condition_negated_while',
        'condition_negated_while_double',

        'condition_negated_repeat',
        'conditional_negated_repeat_with_else',
        'tetris',
        'while_nested_with_negated',
        'conditional_negated_double_repeat_with_else',
        'algo_read'
    ])
    .concat(progressions.functions)
    .concat([
        'pre_boss',
        'pre_boss_2',
        'boss'//,
        //'boss_2'
    ])




progressions.all = progressions.base
    .concat(progressions.conditions)
    .concat(progressions.conditionsElse)
    .concat(progressions.while)
    .concat(progressions.conditionsNegated)
    .concat(progressions.functions)
    .concat([
        'pre_boss',
        'pre_boss_2',
        'boss'//,
        //'boss_2'
    ])


export default progressions


